// Environments for Cloudinary
export const env =
  window.location.href.includes("localhost") ||
  window.location.href.includes("heroku") ||
  window.location.href.includes(".xyz")
    ? "avc-dev"
    : "avc-prod";
